import { useEffect, useState } from 'react';
import { EDocumentSortBy, EDocumentSortType, IGetDocumentItem, IGetDocumentListParams } from 'types/document';
import { getDocumentList } from 'api/documentApi';
import { getGPDocumentList } from 'api/group';

const useGetDocument = (clientId?: number, autoFetch = false, isPracticeView = false): [IGetDocumentItem[] | undefined, boolean, boolean, number, (param: IGetDocumentListParams) => void] => {
    const [documents, setDocuments] = useState<IGetDocumentItem[]>();
    const [hasDocuments, setHasDocuments] = useState(false);
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);

    const defautParams: IGetDocumentListParams = {
        current: 1,
        size: 10,
        sortBy: EDocumentSortBy.UPLOAD_TIME,
        sortType: EDocumentSortType.DESC,
        tags: [],
    };
    const fetchDocument = async (param?: IGetDocumentListParams) => {
        try {
            setLoading(true);
            const apiCall = isPracticeView ? getGPDocumentList : getDocumentList;
            const result = await apiCall(param ? param : { ...defautParams, clientId });
            if (!result.error) {
                setDocuments(result.data?.data?.list || []);
                const total = result.data?.data?.totalRecords || 0;
                setTotalRecords(total);
                setHasDocuments(total > 0);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!clientId) {
            setDocuments(undefined);
            setHasDocuments(false);
            setTotalRecords(0);
            return;
        }
        if (autoFetch) {
            fetchDocument({ ...defautParams, clientId });
        }
    }, [autoFetch, clientId]);

    return [documents, hasDocuments, loading, totalRecords, fetchDocument,];
};

export default useGetDocument;